import { CrossAssociation } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/CrossAssociation';
import { EnumMultiplicity } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumMultiplicity';
import { EnumRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';
export class CrossAssociationExtend {
  public static Init(dto: CrossAssociation) {
    dto.relationshipType = EnumRelationshipType.CrossAssociation;
    dto.sourceMultiplicity = EnumMultiplicity.OneMany;
    dto.targetMultiplicity = EnumMultiplicity.OneMany;
  }
}
